import React, { useEffect } from "react";
import { Collapse, Divider } from "antd";
import "./nujobsMyEvalsResults.scss";
import QSetCandidateExamCard from "../../qsetcandidateExamCard";
import useNuJobsStore from "../../../store/nujobsevals.store";
import { useParams } from "react-router-dom";

const NuJobsMyEvalsResults = ({}) => {
  const { myQuestions, getMyEvalResults, myEvalResults } = useNuJobsStore();
  const evaluationName = "React Assessment";
  const { ev_id } = useParams();

  useEffect(() => {
    getMyEvalResults(ev_id);
  }, []);

  const formatExamData = (qdesc) => {
    if (!qdesc || !Array.isArray(qdesc.answers)) {
      // Changed keys to match your destructuring below
      return { localQDesc: [], localQAnswer: [] };
    }

    const questions = [];
    const answers = [];

    qdesc.answers.forEach((ans) => {
      // 1. Format for localQDesc
      questions.push({
        ID: ans.questionid || "",
        qhglobaljid: "",
        qhcompanyjid: "",
        qhoid: "",
        accounttype: "",
        questionid: ans.questionid || "",
        questiontype: ans.questiontype || "Multiple Choice",
        source: "Custom",
        question: ans.question || "",
        multiplechoicecode: "",
        optiona: ans.optiona || "A",
        optionb: ans.optionb || "B",
        optionc: ans.optionc || "C",
        optiond: ans.optiond || "D",
        optioninput: "",
        answer: ans.correctanswer || "",
        code: ans.codeinput || "",
        output: ans.codeoutput || "",
        explanation: "Custom",
        comments: "",
        skill: ans.skill || "",
        assessmenttype: ans.assessmenttype || "",
        category: "",
        level: "",
        updatedby: {
          updatedon: qdesc.takendate || "",
          qhuid: "1",
          name: "",
          remarks: "",
          timestamp: ans.timestamp || 0,
        },
        timestamp: ans.timestamp || 0,
      });

      // 2. Format for localQAnswer (localADesc)
      answers.push({
        localStatus:
          ans.selectedoption !== undefined ? "Answered" : "Unanswered",
        question: ans.question || "",
        questionid: ans.questionid || "",
        questiontype: ans.questiontype || "Multiple Choice",
        output: ans.codeoutput || "",
        code: ans.codeinput || "",
        inputanswer: ans.inputanswer || "",
        mark: ans.mark ?? 0,
        correctanswer: ans.correctanswer || "",
        saveStatus: true,
        option: ans.selectedoption ?? 0,
      });
    });

    // Return the keys exactly as you destructure them in the map
    return { localQDesc: questions, localQAnswer: answers };
  };

  return (
    <div className="nujobs-my-evals-results-wrapper">
      {/* Fixed <dic> to <div> */}
      <div className="nujobs-my-evals-results-question-paper">
        {myEvalResults?.map((qdesc, idx) => {
          const { localQDesc, localQAnswer } = formatExamData(qdesc);

          return (
            <Collapse
              key={idx}
              style={{ width: "90%", margin: "auto", marginBottom: "20px" }}
              items={[
                {
                  key: idx,
                  label: `Attempted On: ${qdesc?.takendate}`,
                  children: (
                    <>
                      <div className="evaluation-card">
                        <div className="evaluation-header">
                          <h3 className="evaluation-name">{evaluationName}</h3>
                          <span
                            className={`status-badge ${qdesc?.resultstatus?.toLowerCase() === "pass" ? "pass" : "fail"}`}
                          >
                            {qdesc?.resultstatus}
                          </span>
                        </div>

                        <div className="evaluation-body">
                          <div className="metric-box">
                            <span className="metric-label">Marks</span>
                            <span className="metric-value">
                              {qdesc?.totalmarks}
                            </span>
                          </div>

                          <div className="metric-box">
                            <span className="metric-label">
                              Weightage Marks
                            </span>
                            <span className="metric-value">
                              {qdesc?.wmarks}
                            </span>
                          </div>

                          <div className="metric-box">
                            <span className="metric-label">Percentage</span>
                            <span className="metric-value">
                              {qdesc?.percentage}%
                            </span>
                          </div>
                        </div>
                      </div>

                      {/* Added missing return statement and key for React list rendering */}
                      {qdesc?.answers.map((ans, ansIdx) => {
                        return (
                          <QSetCandidateExamCard
                            key={ansIdx}
                            index={ansIdx}
                            localQDesc={localQDesc}
                            localADesc={localQAnswer}
                            isReviewMode={true}
                          />
                        );
                      })}
                    </>
                  ),
                },
              ]}
            />
          );
        })}
      </div>
    </div>
  );
};

export default NuJobsMyEvalsResults;
